import { inject, Injectable } from "@angular/core";
import { MultichainContactsRemote } from "@main-services/multichain-contacts.remote";
import { Observable } from "rxjs";
import { SendTransaction } from "@models/transaction";
import { Fee } from "@modules/main/components/step-summary/sending-modal/entities/fee.model";

@Injectable()
export class MultichainContactsService {
	private readonly contactsRemote: MultichainContactsRemote = inject(MultichainContactsRemote);

	public validateContactAndGetFee(walletId: string, transaction: SendTransaction): Observable<Fee> {
		return this.contactsRemote.validateContactAndGetFee(walletId, transaction);
	}
}
